import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function Soil() {
  return (
    <section className="imt-service-section py-5">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-8">
            <div className="imt-glass-card shadow-lg p-4">
              <div className="imt-image-frame mb-4">
                <img
                  src="images/services/DSC_1813.JPG"
                  alt="Soil Testing"
                  className="img-fluid rounded-4"
                />
                <span className="imt-tag">IMT • Soil Testing</span>
              </div>

              <h2 className="imt-title mb-3">Soil Testing</h2>

              <p className="imt-body">
                IMT’s understanding of Florida’s soil profiles forms the
                backbone of our company. Our team is equipped with
                state-of-the-art instruments and a deep awareness of local
                municipality requirements. From compaction to classification, we
                deliver accurate, on-time testing that keeps your job moving
                forward without delays.
                <br />
                <br />
                Whether you're preparing foundations, grading a site, or
                validating material performance — IMT ensures the ground beneath
                your project is verified, documented, and dependable.
              </p>

              <div className="row mt-4">
                <div className="col-12">
                  <h4 className="imt-subtitle mb-3">
                    Our Soil Testing Services
                  </h4>
                </div>

                <div className="col-md-6">
                  <ul className="imt-checklist">
                    <li>Density Testing</li>
                    <li>Proctors</li>
                    <li>LBR</li>
                    <li>CBR</li>
                    <li>Gradation</li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <ul className="imt-checklist">
                    <li>Atterberg Limits</li>
                    <li>Organic Content</li>
                    <li>-200 Wash</li>
                    <li>Moisture Testing</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="imt-sidebar">
              <div className="imt-side-nav mb-4">
                <h4 className="sidebar-title">Services</h4>
                <ul>
                  <li>
                    <a href="/soil" className="active-link">
                      Soil Testing
                    </a>
                  </li>
                  <li>
                    <a href="/geophysical">Geophysical Testing</a>
                  </li>
                  <li>
                    <a href="/concrete">Concrete Testing</a>
                  </li>
                  <li>
                    <a href="/asphalt">Asphalt Testing</a>
                  </li>
                </ul>
              </div>

              <div
                className="imt-help-box"
                style={{
                  backgroundImage: 'url("images/DSC_0202.JPG")',
                }}
              >
                <div className="inner">
                  <h3>Need Assistance?</h3>
                  <p>Speak with our testing specialists.</p>
                  <a href="tel:+18139941164" className="imt-help-number">
                    +1 (813) 994 1164
                  </a>
                  <a
                    href="/contact"
                    className="btn btn-light mt-2 imt-help-btn"
                  >
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="imt-bg-shape imt-bg-1"></div>
      <div className="imt-bg-shape imt-bg-2"></div>

      <style>{`
        .imt-service-section {
          position: relative;
          background: #f3f3f9;
          overflow: hidden;
        }

        .imt-glass-card {
          background: rgba(255,255,255,0.8);
          backdrop-filter: blur(10px);
          border-radius: 18px;
          position: relative;
          z-index: 2;
        }

        .imt-image-frame {
          position: relative;
        }
        .imt-tag {
          position: absolute;
          bottom: 12px;
          left: 12px;
          background: #077325;
          padding: 6px 12px;
          color: white;
          font-size: 0.8rem;
          border-radius: 5px;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        .imt-title {
          font-size: 2.4rem;
          font-weight: 800;
          color: #077325;
          text-shadow: 1px 1px 0px #99a6c4;
        }
        .imt-subtitle {
          font-weight: 700;
          color: #077325;
        }
        .imt-body {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #2d2d2d;
        }

        .imt-checklist li {
          list-style: none;
          margin-bottom: 10px;
          font-weight: 600;
          padding-left: 30px;
          position: relative;
        }
        .imt-checklist li::before {
          content: "✔";
          position: absolute;
          left: 0;
          top: 2px;
          font-size: 1rem;
          color: #1e66ff;
        }

        .imt-side-nav {
          background: white;
          border-radius: 14px;
          padding: 20px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.1);
        }
        .imt-side-nav ul {
          list-style: none;
          padding-left: 0;
        }
        .imt-side-nav ul li {
          margin-bottom: 10px;
        }
        .imt-side-nav ul li a {
          text-decoration: none;
          padding: 10px 15px;
          display: block;
          border-radius: 10px;
          font-weight: 600;
          color: #077325;
          transition: 0.3s;
        }
        .imt-side-nav ul li a:hover {
          background: #077325;
          color: white;
        }
        .active-link {
          background: #077325 !important;
          color: white !important;
        }

        .imt-help-box {
          background-size: cover;
          background-position: center;
          border-radius: 18px;
          padding: 40px 20px;
          margin-top: 25px;
          position: relative;
          overflow: hidden;
          box-shadow: 0 6px 20px rgba(0,0,0,0.3);
        }
        .imt-help-box::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.55);
        }
        .imt-help-box .inner {
          position: relative;
          z-index: 2;
          color: white;
        }
        .imt-help-number {
          font-size: 1.4rem;
          display: block;
          margin-top: 5px;
          color: #ffffff;
          text-decoration: none;
        }
        .imt-help-btn {
          font-weight: bold;
          border-radius: 8px;
        }
        .imt-help-btn:hover {
          background: #077325 !important;
          color: white !important;
        }
      `}</style>
    </section>
  );
}

export default Soil;
